export function removeFilter(filter: any, fieldToRemove: string) {
  if (filter === undefined) return filter;

  if (filter.logic !== undefined) {
    filter.filters = filter.filters
      .map((val: any) => {
        if (!val) {
          return null;
        }
        if (
          !val.field &&
          val.filters &&
          typeof val.filters === "object" &&
          typeof val.logic === "string"
        ) {
          val.filters = removeFilter(val.filters, fieldToRemove);

          if (val.filters.length === 0) val = null;
          return val;
        }
        if (val.field !== fieldToRemove) return val;

        return null;
      })
      .filter((val: any) => val !== null);

    if (filter.filters.length === 0) filter = null;
  } else {
    filter = filter
      .map((val: any) => {
        if (val.field !== fieldToRemove) return val;
        return null;
      })
      .filter((val: any) => val !== null);
  }

  return filter;
}
